<div class="timecards-page no-print">
    <ppw-toolbar [menuTitle]="pageTitle" showMenu="true" singleButton="!viewingMode">
        <div class="ppw-speed-dial-position">
            <div
                class="button-wrapper"
                [matTooltip]="
                    hasLockedInSelection
                        ? 'Can\'t delete timecard(s) that is / are locked'
                        : selectedTimeCards.length >= 2
                        ? 'Delete timecard group'
                        : 'Delete timecard'
                ">
                <button
                    mat-mini-fab
                    class="speed-dial-button"
                    *ngIf="selectedTimeCards.length >= 1"
                    color="warn"
                    [disabled]="hasLockedInSelection"
                    (click)="deleteTimecard()">
                    <mat-icon>delete_forever</mat-icon>
                </button>
            </div>
            <div
                class="button-wrapper"
                [matTooltip]="
                    hasLockedInSelection && selectedTimeCards.length >= 2
                        ? 'Can\'t edit timecard(s) that is / are locked'
                        : selectedTimeCards.length >= 2
                        ? 'Edit timecard group'
                        : hasLockedInSelection
                        ? 'Only edit description allowed'
                        : 'Edit timecard'
                ">
                <button
                    mat-mini-fab
                    class="speed-dial-button"
                    *ngIf="selectedTimeCards.length >= 1"
                    [disabled]="hasLockedInSelection && selectedTimeCards.length >= 2"
                    (click)="editTimecard()">
                    <mat-icon>mode_edit</mat-icon>
                </button>
            </div>
            <button
                mat-mini-fab
                class="speed-dial-button"
                *ngIf="selectedTimeCards.length === 1"
                (click)="copyTimecard()"
                matTooltip="Copy timecard">
                <mat-icon>content_copy</mat-icon>
            </button>
            <button
                mat-mini-fab
                class="speed-dial-button"
                *ngIf="selectedTimeCards.length === 1"
                (click)="detailTimecard()"
                matTooltip="Details timecard">
                <mat-icon>find_in_page</mat-icon>
            </button>
            <button
                mat-mini-fab
                class="speed-dial-button"
                *ngIf="selectedTimeCards.length < 2"
                (click)="createTimeCard()"
                matTooltip="Create timecard">
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
    </ppw-toolbar>
    <ppw-app-date-selector [config]="dateSelectorConfig" (emitCriteria)="fetchTimecardsWithDates($event)">
    </ppw-app-date-selector>
    <div class="table-container">
        <table
            mat-table
            multiTemplateDataRows
            [dataSource]="datasource$"
            (mousedown)="$event.shiftKey ? $event.preventDefault() : null"
            class="mat-elevation-z8 ppw-list">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">
                    <div class="{{ element.indentLvl !== undefined ? 'row-indent-' + element.indentLvl : '' }}">
                        <div fxLayoutAlign="start center">
                            <mat-icon *ngIf="element.children">
                                {{ element.isExpanded ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                            <mat-icon
                                *ngIf="element.icon"
                                [class]="element.colorByGroupBy ? element.colorByGroupBy : 'timecard'"
                                class="margin-right"
                                [class.extra-margin-left]="!element.children">
                                {{ element.icon }}
                            </mat-icon>
                            <mat-icon
                                *ngIf="!element.icon"
                                class="timecard margin-right extra-margin-left"
                                [matTooltip]="
                                    element.timecardStatusEnum === 3
                                        ? 'This timecard is locked'
                                        : element.timecardStatusEnum === 1
                                        ? 'This timecard is edited'
                                        : 'Timecard'
                                ">
                                {{
                                    element.timecardStatusEnum === 3
                                        ? 'lock'
                                        : element.timecardStatusEnum === 1
                                        ? 'timelapse'
                                        : 'alarm'
                                }}
                            </mat-icon>
                            {{ element.name ? element.name : element.issueTitle }}
                        </div>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="HTC">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayoutAlign="end center">
                        <span matTooltip="Hours to charge">HTC</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                    <span fxLayoutAlign="end center">
                        {{ getHours(element.secondsToInvoice) }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="HNC">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayoutAlign="end center">
                        <span matTooltip="Hours no charge">HNC</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element" class="warn">
                    <span fxLayoutAlign="end center">
                        {{ getHours(element.secondsNoInvoice) }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="HTT">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayoutAlign="end center">
                        <span matTooltip="Hours total">HTT</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                    <span fxLayoutAlign="end center">
                        {{ getHours(element.secondsToInvoice + element.secondsNoInvoice) }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="DTC">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayoutAlign="end center">
                        <span matTooltip="Days to charge">DTC</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                    <span fxLayoutAlign="end center">
                        {{ getDays(element.secondsToInvoice) }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="DNC">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayoutAlign="end center">
                        <span matTooltip="Days no charge">DNC</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element" class="warn">
                    <span fxLayoutAlign="end center">
                        {{ getDays(element.secondsNoInvoice) }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="DTT">
                <th mat-header-cell *matHeaderCellDef>
                    <div fxLayoutAlign="end center">
                        <span matTooltip="Days total">DTT</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                    <span fxLayoutAlign="end center">
                        {{ getDays(element.secondsToInvoice + element.secondsNoInvoice) }}
                    </span>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr
                mat-row
                *matRowDef="let element; columns: displayedColumns"
                (click)="select(element, $event)"
                (dblclick)="dbClickTimecard(element)"
                [class.detail-row-highlight]="element | highlight : selectedTimeCards"></tr>
        </table>
    </div>
</div>
